// @flow
import * as React from 'react';
import { Container, Header, Title, Text, Button, Icon, Footer, Left, Body, Right, ListItem } from 'native-base';
import { Platform, Linking, WebView } from 'react-native';
import { connect } from 'react-redux';

import Reports from './reports';

import ReportFilter from '../../components/reportFilter';
import * as _ from 'lodash';

import HamburgerMenu from '../../components/hamburgerMenu';
import { loadPreviews, loadReport, loadFilters } from './actions';
import CalCalDataApi from '../../api/CalCalDataApi';
import GLOBALS from '../../components/globals';

/*
Loads /reports from API and presents list (<Reports>) with props.data if params.url is not set
If params.url (and a filter is loaded/selected), show either webview or that sub-view as the content (see renderContent)



*/

export interface State {}
class ReportsContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		//load some stuff depending on the report we're showing.
		//These may be left in the reducer and available from last time

		//loadPreviews should show a little preview for each report
		this.props.loadPreviews();
		//load filters for years/dates
		this.props.loadFilters();
	}

	render() {
		return (
			<Container>
				<Header>
					<Left>
						<HamburgerMenu />
					</Left>
					<Body>
						<Title>Reports</Title>
					</Body>
					<Right />
				</Header>
				<Reports navigation={this.props.navigation} list={this.props.data} />
			</Container>
		);
	}
}

function bindAction(dispatch) {
	return {
		fetchList: url => dispatch(fetchList(url)),
		loadPreviews: () => dispatch(loadPreviews()),
		loadFilters: () => dispatch(loadFilters()),
		dispatch
	};
}

const mapStateToProps = state => ({
	data: state.reportsReducer.reports, //list,
	isLoading: state.reportsReducer.isLoading,
	user: state.loginReducer.user,
	filters: state.reportsReducer.filters,
	taxyear: state.reportsReducer.taxyear,
	filter: state.reportsReducer.filter,
	vatReg: state.globalReducer.busDetails.vatRegistered
});
export default connect(mapStateToProps, bindAction)(ReportsContainer);
